const guest = require('./distribution/guest');

module.exports = guest;
